import { Component, OnInit } from '@angular/core';
import { Image2Base64ConverterService } from 'src/app/services/image2-base64-converter.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-test',
    templateUrl: './test.component.html',
    styleUrls: ['./test.component.scss'],
    standalone: false
})
export class TestComponent implements OnInit {
  imageUrl: String = 'http://165.227.92.103:3000/api/v1/docs/1605133742629.jpeg';
  result:any = '';

  constructor(
    private base64:Image2Base64ConverterService,
    private FormsModule:FormsModule
  ) {}

  ngOnInit(): void {
  }

  async handleConvert() {
   this.result = await this.base64.convert(this.imageUrl)
  }
}
